module.exports = __webpack_public_path__ + "app/principal/group/principal-group-cy8fYxOC.html";